import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import toastsActionCreators from "~/store/toasts/actions";
import { Button, Modal, Alert } from "~/components-shared";
import authSelectors from "~/store/auth/selectors";
import authActionCreators from "~/store/auth/actions";
import ProfileStatusForm from "~/forms/ProfileStatusForm";
import profileStatusSchema from "~/forms/ProfileStatusForm/profileStatusSchema";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ProfileStatusUpdateModal = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const status = useSelector(authSelectors.getStatus);
  const error = useSelector(authSelectors.getError);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    resolver: yupResolver(profileStatusSchema),
    defaultValues: user.metadata
  });
  const list = {
    "📅": t("common.profileStatus.planning"),
    "✋": t("common.profileStatus.requesting"),
    "🤝": t("common.profileStatus.collaborating"),
    "🎯": t("common.profileStatus.focusing"),
    "✏️": t("common.profileStatus.slackMe"),
    "📬": t("common.profileStatus.emailMe"),
    "🤒": t("common.profileStatus.outSick"),
    "🌴": t("common.profileStatus.onVacation"),
    "🎉": t("common.profileStatus.celebrating")
  };
  const onSubmit = handleSubmit(data => {
    dispatch(authActionCreators.updateStatusStarted(data, _ref2 => {
      let {
        data: newUser
      } = _ref2;
      if (newUser) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("ProfileStatusUpdateModal.statusUpdated"),
          timeout: 10000
        }));
        onClose();
      }
    }));
  });
  const handleCancel = () => {
    dispatch(authActionCreators.actionChanged(undefined));
    onClose();
  };
  const handleSetStatus = (emoji, text) => {
    setValue("statusEmoji", emoji);
    setValue("statusText", text);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    onClose: onClose,
    title: t("ProfileStatusUpdateModal.setStatus"),
    maxWidth: "560px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ProfileStatusForm, {
    control: control
  }), /*#__PURE__*/React.createElement("div", null, Object.keys(list).map(key => /*#__PURE__*/React.createElement(Button, {
    key: key,
    display: "inline-block",
    color: "grey",
    s: {
      py: 2,
      px: 4,
      m: 1
    },
    rounded: true,
    onClick: () => handleSetStatus(key, list[key])
  }, key, " ", list[key])))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true,
    display: "inline-block"
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    display: "inline-block",
    maxWidth: "230px",
    type: "submit",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("common.actions.save")))));
};
export default ProfileStatusUpdateModal;